<template>
  <div v-if="check">
    <el-tabs v-model="activeName">
      <el-tab-pane label="測試帳號登入" name="first">
        <el-col :span="5">
          <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" style="margin-top:50px">
            <el-form-item label="平台" prop="platform">
              <el-input v-model="ruleForm.platform" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="帳號" prop="user" >
              <el-input v-model="ruleForm.user" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm()">提交</el-button>
            </el-form-item>
          </el-form>
          <div>
          <a :href="url2" v-if="url2 != ''" target="_blank" style="font-size:22px; margin:50px">抽獎連結</a>
          </div>
        </el-col>
        <el-col :span="5">
            <a style="font-size:22px">測試帳號</a>
            <a style="font-size:22px">點擊表格輸入內容</a>
            <el-table
              :data="tableData"
              style="width: 100%"
              @row-click="rowclick">
              <el-table-column
                prop="platform"
                label="平台"
                width="180">
              </el-table-column>
              <el-table-column
                prop="user"
                label="帳號"
                width="180">
              </el-table-column>
            </el-table>
        </el-col>
      </el-tab-pane>
      <el-tab-pane label="測試帳號登入(外接API)" name="fourth">
          <el-col :span="5">
            <el-form :model="ruleForm_external" status-icon ref="ruleForm_external" label-width="100px" style="margin-top:50px">
              <el-form-item label="平台" prop="platform">
                <el-input v-model="ruleForm_external.platform" style="width:220px"></el-input>
              </el-form-item>
              <el-form-item label="帳號" prop="user" >
                <el-input v-model="ruleForm_external.user" style="width:220px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm_external()">提交</el-button>
              </el-form-item>
            </el-form>
            <div>
            <a :href="url_external" v-if="url_external != ''" target="_blank" style="font-size:22px; margin:50px">抽獎連結</a>
            </div>
          </el-col>
          <el-col :span="5">
              <a style="font-size:22px">測試帳號</a>
              <a style="font-size:22px">點擊表格輸入內容</a>
              <el-table
                :data="tableData_external"
                style="width: 100%"
                @row-click="rowclick_external">
                <el-table-column
                  prop="platform"
                  label="平台"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="user"
                  label="帳號"
                  width="180">
                </el-table-column>
              </el-table>
          </el-col>
      </el-tab-pane>

      <el-tab-pane label="查詢總流水" name="second">
       <el-col :span="5">
            <a style="font-size:22px">測試API 查詢總流水</a>
            <el-form :model="reportFrom" status-icon ref="reportFrom" label-width="100px" style="margin-top:50px">
              <el-form-item label="平台" prop="platform">
                <el-input v-model="reportFrom.platform" style="width:220px"></el-input>
                <!-- <el-select v-model="reportFrom.platform" placeholder="请选择">
                  <el-option v-for="item in tableData" :key="item.platform" :label="item.platform" :value="item.platform">
                  </el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="帳號" prop="user">
                <el-input v-model="reportFrom.user" style="width:220px"></el-input>
              </el-form-item>
              <el-form-item label="開始時間" prop="starttime">
                <el-date-picker v-model="reportFrom.starttime" value-format="yyyy-MM-dd" type="date" placeholder="">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="結束時間" prop="endtime">
                <el-date-picker v-model="reportFrom.endtime" value-format="yyyy-MM-dd" type="date" placeholder="">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitReportForm()">提交</el-button>
              </el-form-item>
            </el-form>
            <span>會員總流水: {{ vaildBet }}</span>
        </el-col>
      </el-tab-pane>
      <el-tab-pane label="查詢會員狀態" name="third">
        <el-col :span="7">
          <a style="font-size:22px">測試API 查詢會員狀態</a>
          <el-form :model="checkFrom" status-icon ref="checkFrom" label-width="100px" style="margin-top:50px">
            <el-form-item label="平台" prop="platform">
              <el-input v-model="checkFrom.platform" style="width:220px"></el-input>
              <!-- <el-select v-model="checkFrom.platform" placeholder="请选择">
                <el-option v-for="item in tableData" :key="item.platform" :label="item.platform" :value="item.platform">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="帳號" prop="user">
              <el-input v-model="checkFrom.user" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitCheckForm()">提交</el-button>
            </el-form-item>
          </el-form>
          <span>會員狀態: {{ status }}</span>
        </el-col>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import md5 from "js-md5";

  export default {
    data() {
      return {
        activeName: 'first',
        check: true,
        ruleForm: {
          user: '',
          platform: '',
          peid: ''
        },
        ruleForm_external: {
          user: '',
          platform: '',
          token: ''
        },
        reportFrom: {
          user: '',
          starttime: '',
          endtime: '',
          platform: ''
        },
        checkFrom: {
          user: '',
          platform: ''
        },
        url: '',
        url2: '',
        url_external: '',
        vaildBet: 0,
        status: '',
        tableData_external: [
          {
            platform: '1688',
            user: '0906366463',
            token: 'NjMwMzE0NDgtZWYwMS00M2YwLWI5YmMtNzhlMDQ1NDMwODY3'
          },
          {
            platform: '1688',
            user: '0917067496',
            token: 'MWFlY2ExMjQtMGZkNS00YzI3LTljMjQtYzY5NjdmNDhjNTk1'
          },
        ],
        tableData: [
          {
            platform: '1688',
            user: '0917067496',
            peid: '1672371751'
          },
          {
            platform: '1688',
            user: '0906366463',
            peid: '1672371751'
          },
          {
            platform: '1688',
            user: '0938251288',
            peid: '1672371751'
          },
          {
            platform: '1688',
            user: '0928061381',
            peid: '1672371751'
          },
          {
            platform: '918',
            user: '0917067496',
            peid: '1672381084'
          },
          {
            platform: '168',
            user: 'sg008',
            peid: '1672381973'
          },
          {
            platform: '18',
            user: 'sg008',
            peid: '1672382507'
          }
        ]
      };
    },
  mounted() {
    this.password()
  },
    methods: {
      submitCheckForm() {
        this.status = "查詢中.."
        let postData = {
          User: this.checkFrom.user,
          Platform: this.checkFrom.platform
        }
        fetch('/api/linkCheck',
          { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
            if (res.data != 404) {
              this.status = res.data
            } else {
              this.status = "API出錯"
            }
          })
      },
      submitReportForm() {
        this.vaildBet = "查詢中.."
        let postData = {
          User: this.reportFrom.user,
          Starttime: this.reportFrom.starttime+" 00:00:00",
          Endtime: this.reportFrom.endtime+" 23:59:59",
          Platform: this.reportFrom.platform
        }
        fetch('/api/linkReport',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.data != 404) {
            this.vaildBet = res.data
          }else{
            this.vaildBet = "API出錯"
          }
        })
      },
      password() {
        // var result = prompt("pwd");
        // if (result != 'xjp6q06') {
        //   this.check = false
        //   location.replace("http://www.google.com");
        // }
      },
      rowclick_external(row) {
        this.ruleForm_external.platform = row.platform
        this.ruleForm_external.user = row.user
        this.ruleForm_external.peid = row.peid
        this.ruleForm_external.token = row.token
        console.log(row)
      },
      rowclick(row) {
        this.ruleForm.platform = row.platform
        this.ruleForm.user = row.user
        this.ruleForm.peid = row.peid
      },
      submitForm() {
        const nowtime = this.Date()
        let s = this.ruleForm.user + this.ruleForm.platform + nowtime + '07098deee6900ecb19a43b368a06c9ff'
        let token = md5(s)
        // this.url2 = "fifa" + this.ruleForm.platform + "?user=" + this.ruleForm.user + "&p=" + this.ruleForm.platform + "&token=" + token//fifa
        this.url2 = "entry?user=" + this.ruleForm.user + "&p=" + this.ruleForm.platform + "&token=" + token
      },
      submitForm_external() {
        this.url_external = "entry?user=" + this.ruleForm_external.user + "&p=" + this.ruleForm_external.platform + "&token=" + this.ruleForm_external.token
      },
      Date() {
        const nowDate = new Date();
        const date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          date: nowDate.getDate(),
          hours: nowDate.getHours(),
          minutes: nowDate.getMinutes(),
          seconds: nowDate.getSeconds(),
        };

        const newmonth = date.month >= 10 ? date.month : "0" + date.month;
        const newday = date.date >= 10 ? date.date : "0" + date.date;
        return date.year +"-" +newmonth +"-" +newday;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/link.vue